import "./ProcessFlow.css";

function ProcessFlow({
  eyebrow,
  title,
  text,
  ctaLabel,
  ctaHref = "/kontakt",
  step1Title,
  step1Text,
  step2Title,
  step2Text,
  step3Title,
  step3Text,
}) {
  return (
    <section className="process-container fade-section">
      <div className="process-inner">
        <div className="process-header">
          <div className="process-header-copy">
            <h2>{title}</h2>
            {text && <p>{text}</p>}
          </div>
        </div>

        <div className="process-flow">
          <div className="process-step">
            <div className="process-pill">
              <span className="process-step-index">1</span>
              <h3>{step1Title}</h3>
              <p>{step1Text}</p>
            </div>
          </div>

          <div className="process-arrow">
            <span className="process-arrow-line" />
          </div>

          <div className="process-step">
            <div className="process-pill">
              <span className="process-step-index">2</span>
              <h3>{step2Title}</h3>
              <p>{step2Text}</p>
            </div>
          </div>

          <div className="process-arrow">
            <span className="process-arrow-line" />
          </div>

          <div className="process-step">
            <div className="process-pill">
              <span className="process-step-index">3</span>
              <h3>{step3Title}</h3>
              <p>{step3Text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProcessFlow;
